import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    users: [],
    artists: [],
    companyAdmins: [],
    countries: [],
    validation: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    additionalInfoLoader: false,
    additionalData: []
  },

  mutations: {
    setUsers(state, payload) {
      state.users = payload
    },
    setMcnPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setArtists(state, payload) {
      state.artists = payload
    },
    setCompanyAdmin(state, payload) {
      state.companyAdmins = payload
    },
    setCountry(state, payload) {
      state.countries = payload
    },
    setValidation(state, payload) {
      state.validation = payload
    },
    setWallet(state, amount) {
      state.user.wallet = amount
    },
    setImage(state, image) {
      state.user.image_url = image
    },
    setAdditionalInfo(state, data) {
      state.additionalData = data
    },
    setAdditionalInfoLoader(state, bool) {
      state.additionalInfoLoader = bool
    }
  },

  actions: {
    readMcnUsers({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('user_filter')
      filters = ls ? JSON.parse(ls) : {}
      filters.user_level = 'company_user'

      axios.admin
        .get('user', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          r.data.data.data.forEach(s => {
            if (s.wallet !== null) {
              s.wallet = s.wallet/10
            }
            if (!s.channels.youtube || s.channels.youtube.approved !== 1) {
              s.creator_tier = null
            }
          })
          commit('setUsers', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    async getAdditionalInfo({ commit }, userId) {
      try {
        commit('setAdditionalInfoLoader', true)
        const additionalData = await axios.admin.get(
          `user/creator/${userId}/info`, {
              params: { extend: 1 }
            }
        )

        if (additionalData.data.success) {
          commit('setAdditionalInfo', additionalData.data.data)
          commit('setAdditionalInfoLoader', false)
        }
      } catch (e) {
        commit('setAdditionalInfoLoader', false)
      }
    }
  }
}
